import {useState,useEffect,useRef} from 'react'; 
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import {Tablescom} from '../../components/tablescomp';
import { manufacturerServices } from '../../services/manufacturerServices';
import {Titlebar,Searchbox, Confirmdelete} from  '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate   } from "react-router";
import { Dialog } from 'primereact/dialog';
import {localurl} from '../../constant';
import {convertFileToBase64} from '../../helpers/base64conversion';
import { Toast } from "primereact/toast";

const Manufacturer = () =>{

    const navigate = useNavigate();
    const [users,setUsers] = useState([]);
    const [results,setResults] = useState([]);
    const [userloaded,setUserloaded] = useState(true);
    const [visible,setVisible] = useState(false);
    const [popvisible,setPopvisible] = useState(false);
    const [deleleteid,setDeleleteid] = useState(false);
    const [viewmanufacturer,setViewmanufacturer] = useState([]);
    const [viewvisible,setViewvisible] = useState(false);
    const toast = useRef(null);
    const [quickFilterText, setQuickFilterText] = useState('');
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5); // 🔄 dynamic page size



  useEffect(()=>{
      getallmanufacturer(currentPage,pageSize);
    },[currentPage,pageSize]); 

  useEffect(() => {
      setColDefs(getColDefs(currentPage, pageSize));
  }, [currentPage, pageSize]);

  const handleNext = () => {
    if (currentPage < Math.ceil(totalRows / pageSize)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const deletemanufacturer = (id) =>{
         setPopvisible(true);
         setDeleleteid(id);
      }
  // const [colDefs, setColDefs] = useState([
  //   {
  //     headerName: "SR NO",
  //     valueGetter: (params) => {
  //       return ((currentPage - 1) * pageSize) + params.node.rowIndex + 1;
  //     },
  //   },
  //   { headerName: "Name",field: "name" },
  //   { headerName: "Email",field: "email" },
  //   { headerName: "Status",field: "status",cellRenderer: (params) => {
  //       return (
  //         params.getValue()=='active' ?'Active':'Inactive'
  //       );
  //     } },
  //   { headerName: "Action",
  //   cellRenderer: (params) => {
  //     // console.log("params");
  //     // console.log(params.data.id);
  //     return (
  //       <>
  //            <button class="btn  btn-xs btn-primary btn-border-none custom-btn-color2" onClick={(e) => editredirect(params.data.id,params.data)}><i class="icon icon-note icon-style color-white"></i></button>
  //            &nbsp;
  //            <button class="btn btn-danger btn-xs btn-white btn-border-none" onClick={(e) => deletemanufacturer(params.data.id)} ><i class="icon icon-trash icon-style color-white"></i></button> 
  //            &nbsp;
  //            <button class="btn btn-success btn-xs btn-white btn-border-none" onClick={(e) => viewmanufacturerdata(params.data.id)}><i class="icon icon-eye icon-style color-white"></i></button> 
  //       </>
       
  //     );
  //   } }
  // ]);

const getColDefs = (currentPage, pageSize) => [
  {
    headerName: "SR NO",
    valueGetter: (params) => {
      return ((currentPage - 1) * pageSize) + params.node.rowIndex + 1;
    },
  },
  { headerName: "Name", field: "name" },
  { headerName: "Email", field: "email" },
  {
    headerName: "Status",
    field: "status",
    cellRenderer: (params) =>
      params.value === "active" ? "Active" : "Inactive",
  },
  {
    headerName: "Action",
    cellRenderer: (params) => (
      <>
        <button
          className="btn btn-xs btn-primary"
          onClick={() => editredirect(params.data.id, params.data)}
        >
          <i className="icon icon-note"></i>
        </button>
        &nbsp;
        <button
          className="btn btn-danger btn-xs"
          onClick={() => deletemanufacturer(params.data.id)}
        >
          <i className="icon icon-trash"></i>
        </button>
        &nbsp;
        <button
          className="btn btn-success btn-xs"
          onClick={() => viewmanufacturerdata(params.data.id)}
        >
          <i className="icon icon-eye"></i>
        </button>
      </>
    ),
  },
];

const [colDefs, setColDefs] = useState(getColDefs(1, 5));


  const editredirect = (id,Data) =>{
    navigate(`/editmanufacturer/${id}`, { state: { manufacturer: Data } });
  }


  const getallmanufacturer  = (page,pageSize)=> {
        setUserloaded(true);
        manufacturerServices.getmanufacturer(page,pageSize).then((response)=>{
            if(response.status == 200){
                setResults(response.data.data);
                setTotalRows(response.data.total);
                setCurrentPage(response.data.current_page);
                setUserloaded(false);
            }else{
                setResults([]);
                // setUsers([]);
                // setUserloaded(true);
            }  
        }).catch((error)=>{
          setResults([]);
            // setUsers([]);
            // setUserloaded(true);
        }); 
  } 

  const addproductnavigate = () =>{
    // navigate.  
    navigate('/addmanufacturer');
  }

  // const uploadmanufacturer = async (e) =>{
  //    e.preventDefault(); 
  //    let file =  e.target.file.files[0];
  //    const base64 = await convertFileToBase64(file);
  //    supplierservices.createmultisupplier(base64).then((response)=>{

  //    }).catch((error)=>{
       
  //    });        
  // }

  const viewmanufacturerdata = (id) =>{
        manufacturerServices.getmanufacturer(id).then((response)=>{
          if(response.status == 200){
            setViewmanufacturer(response.data.data);
            setViewvisible(true);
          }
      }).catch((error)=>{
        
      }); 
   }

    const deletemanufacturerdata = () => {
            if(deleleteid){
            manufacturerServices.deletemanufacturer(deleleteid).then((response)=>{
            if(response.status == 200){
              setPopvisible(false);
              setDeleleteid(false);
              toast.current.show({ severity: 'success', summary: 'Sale', detail: 'Manufacturer deleted successfully' }); 
              getallmanufacturer(currentPage,pageSize);   
            }
        }).catch((error)=>{
          
        }); 
            }

    }

  const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    getallmanufacturer(1, newSize);       // reload with new size
  };

      const canceldiag = () =>{
         setPopvisible(false);
      }

  return(
       <>
       <Toast ref={toast} />
          <Bredcrum title={'Product'} divider={false}/>
        <Confirmdelete popvisible={popvisible} deletefun={deletemanufacturerdata} cancel={canceldiag} title="Manufacturer" />
          
      {/* <Dialog
            header="⚠️ Confirm Deletion"
            visible={popvisible}
            style={{ width: '30vw', borderRadius: '10px' }}
            onHide={() => setPopvisible(false)}
            modal
          >
        <p className="mb-4" style={{ fontSize: '1rem' }}>
          Are you sure you want to delete this manufacturer?
        </p>

        <div className="d-flex justify-content-end gap-2">
          <button
            className="btn btn-secondary rounded-pill px-4"
            onClick={() => setPopvisible(false)}
          >
            Cancel
          </button>
          <button
            className="btn btn-danger rounded-pill px-4"
            onClick={deletemanufacturerdata}
          >
            Delete
          </button>
        </div>
      </Dialog> */}

    <Dialog 
  header="Manufacturer Data View"
  visible={viewvisible}
  style={{ width: '60vw' }}
  onHide={() => setViewvisible(false)}
  // footer={footerContent}
  modal
  className="p-fluid"
>
  <div className="card-body">
    <div className="container mt-4">
      {viewmanufacturer.map((row, index) => (
          <div className="row" key={index}>
              {/* Name */}
              <div className="col-md-6 form-group">
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={row.name || ''} readOnly
                />
              </div>

                      {/* Email */}
                      <div className="col-md-6 form-group">
                        <label>Email</label>
                        <input
                          type="text"
                          name="email"
                          className="form-control"
                          value={row.email || ''} readOnly
                        />
                      </div>

                      {/* Phone */}
                      <div className="col-md-6 form-group">
                        <label>Phone</label>
                        <input
                          type="text"
                          name="phone"
                          className="form-control"
                          value={row.phone || ''} readOnly
                        />
                      </div>

                      {/* Address */}
                      <div className="col-md-6 form-group">
                        <label>Address</label>
                        <input
                          type="text"
                          name="address"
                          className="form-control"
                          value={row.address || ''} readOnly
                        />
                      </div>

                      {/* Shop Name */}
                      <div className="col-md-6 form-group">
                        <label>Contact Person</label>
                        <input
                          type="text"
                          name="contact_person"
                          className="form-control"
                          value={row.contact_person || ''} readOnly
                        />
                      </div>

                      <div className="col-md-6 form-group">
                        <label>GST NO</label>
                        <input
                          type="text"
                          name="gst_no"
                          className="form-control"
                          value={row.gst_no || ''} readOnly
                        />
                      </div>

                      <div className="col-md-6 form-group">
                        <label>Country</label>
                        <input
                          type="text"
                          name="country"
                          className="form-control"
                          value={row.country || ''} readOnly
                        />
                      </div>


                      {/* Type */}
                      <div className="col-md-6 form-group">
                        <label>City</label>
                        <input
                          type="text"
                          name="city"
                          className="form-control"
                          readOnly
                          value={row.city || ''} 
                        />
                      </div>

                      <div className="col-md-6 form-group">
                        <label>Website</label>
                        <input
                          type="text"
                          name="website"
                          className="form-control"
                          readOnly
                          value={row.website || ''} 
                        />
                      </div>

                      <div className="col-md-6 form-group">
                        <label>Status</label>
                            <select class="form-select" id="status" name="status" value={row.status} >
                                <option value="active">Active</option>
                                <option value="">Inactive</option>
                            </select>
                      </div>

                    <div className="col-md-12 form-group">
                        <label>remarks</label>
                        <textarea name="remarks" value={row.notes} className="form-control" readOnly>
                          {row.notes || ''}
                        </textarea>
                      </div>

                    </div>
      ))}
    </div>
  </div>
    </Dialog>

          <div class="row">
              <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                     <div className=''>
                         <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ps-5 pe-5' onClick={() => navigate('/addmanufacturer')}>Add manufacturer</button> 
                         &nbsp;
                         &nbsp;
                         &nbsp; 

                         {/* <button className='btn rounded-pill btn-dark custom-btn-br-color ps-5 pe-5' onClick={() => setVisible(true)}>Add Multi Suppliers</button>  */}

                         {/* <Dialog visible={visible} position='top' modal style={{ width: '50rem' }} onHide={() => {if (!visible) return; setVisible(false); }}>
                             <div class="container">
                                  <h2>Excel Upload & Download</h2>
                                     <a href={localurl+"/storage/templates/supplier.xls"} download class="btn text-primary">Click to Download Excel Template</a>

                                  <form id="uploadForm" onSubmit={(e) => uploadmanufacturer(e)}>
                                    <label for="file">Upload Excel File:</label><br/>
                                    <input type="file" id="file" name="file" accept=".xlsx, .xls" required/><br/>
                                    <button type="submit" class="btn">Upload</button>
                                  </form>
                                 <div id="status" class="status"></div>
                                </div>
                        </Dialog> */}

                <Dialog visible={visible} position='top' modal style={{ width: '50rem' }} onHide={() => {if (!visible) return; setVisible(false); }}>
                  <div className="container py-5">
                    <div className="card shadow-lg rounded-4 p-4">
                      <h2 className="mb-4 text-center text-primary">Excel Multiple Data Upload</h2>

                      <div className="text-center mb-4">
                        <a
                          href={localurl + "/templates/component.xlsx"}
                          download
                          className="btn btn-outline-primary rounded-pill px-4"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download Excel Template
                        </a>
                      </div>
{/* 
                      <form id="uploadForm" onSubmit={(e) => uploadmanufacturer(e)}>
                        <div className="mb-3">
                          <label htmlFor="file" className="form-label fw-semibold">
                            Upload Excel File
                          </label>
                          <input
                            type="file"
                            className="form-control form-control-lg"
                            id="file"
                            name="file"
                            accept=".xlsx, .xls"
                            required
                          />
                        </div>

                        <div className="text-center">
                          <button
                            type="submit"
                            className="btn btn-primary rounded-pill px-5 py-2 custom-btn-color"
                          >
                            Upload
                          </button>
                        </div>
                      </form> */}

                      <div id="status" className="status mt-4 text-center text-success fw-medium"></div>
                    </div>
                  </div>

              </Dialog>
                      </div>
                      <Searchbox 
                      value={quickFilterText}
                       onChange={(e) => setQuickFilterText(e.target.value)}
                      />
                  </div> 
              </div> 
             
              
              <Titlebar text={'Manufacturer List'}/>
              <div className="col-md-12 mt-3">
                  <div className='card'>
                    <div className='card-body card-body-style'>
                     <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} 
                     quickFilterText={quickFilterText}  paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                     totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext} 
                     handlePrevious={handlePrevious}
                     handlePageSizeChange={handlePageSizeChange}/>
                     </div>
                 </div>
              </div>   
          </div>
       </>
    );   
 }
 export default Manufacturer;